import { css } from "styled-components";

export const mobileView = (props) => {
  return css`
    @media only screen and (max-width: 480px) {
      ${props}
    }
  `;
};

export const tabView = (props) => {
  return css`
    @media only screen and (max-width: 870px) {
      ${props}
    }
  `;
};
